import { Controller } from "@hotwired/stimulus";

const DAYS_PER_WEEK = 7;
const MONDAY = 1;

export default class extends Controller {
  // Points a calendar link at the first day of the user's current week, since
  // only the browser knows whether their locale starts weeks on sunday or
  // monday. The backend renders the seven days from the given date onwards.
  connect() {
    const url = new URL(this.element.href);
    url.searchParams.set("week", this.firstDayOfCurrentWeek());
    this.element.href = url;
  }

  firstDayOfCurrentWeek() {
    const date = new Date();
    const offset = (date.getDay() - (this.localeFirstWeekday() % DAYS_PER_WEEK) + DAYS_PER_WEEK) % DAYS_PER_WEEK;
    date.setDate(date.getDate() - offset);

    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0"),
    ].join("-");
  }

  localeFirstWeekday() {
    const locale = new Intl.Locale(navigator.language);
    // weekInfo is an accessor in Chrome/Safari and a method in other engines;
    // fall back to monday-based weeks when the browser supports neither.
    const weekInfo = locale.weekInfo ?? locale.getWeekInfo?.();
    return weekInfo?.firstDay ?? MONDAY;
  }
}
